import MDButton from 'components/MDButton';
import MDBox from 'components/MDBox';
import { NavLink } from 'react-router-dom';

const formatDate = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleString();
};

const gameLeaderboardsColumnData = [
  {
    Header: 'Name',
    accessor: 'name'
  },
  {
    Header: 'Game',
    accessor: 'game.name',
    Cell: ({ row }) => row?.original?.game?.name || '-'
  },
  {
    Header: 'Bet Limit',
    accessor: 'betLimit.id',
    Cell: ({ row }) => row?.original?.betLimit?.id || 'Any'
  },
  {
    Header: 'Starts',
    accessor: 'startAt',
    Cell: ({ row }) => formatDate(row.original.startAt)
  },
  {
    Header: 'Ends',
    accessor: 'endAt',
    Cell: ({ row }) => formatDate(row.original.endAt)
  },
  {
    Header: '',
    accessor: 'view',
    Cell: ({ row }) => (
      <MDBox display='flex' justifyContent='center'>
        <NavLink to={`/leaderboards/${row.original.id}`}>
          <MDButton fontSize='0.875rem' color='info'>
            View
          </MDButton>
        </NavLink>
      </MDBox>
    )
  }
];

export default gameLeaderboardsColumnData;
